<template>
  <v-container fluid :class="$style['container']">
    <v-overlay :value="loading || processing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <ToolBar :class="$style['container-header']">
      <template v-slot:left>
        <Breadcrumb :items="breadcrumbs" />
      </template>
      <template v-slot:right>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon @click="onRefresh" v-on="on">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>再読込</span>
        </v-tooltip>
      </template>
    </ToolBar>
    <div :class="$style['container-content']">
      <v-content class="app-content">
        <div :class="$style['main-content']">
          <template v-if="loaded">
            <template v-if="error">
              <div :class="$style['container-error']">
                <p>
                  <v-icon color="red darken-2">mdi-alert-circle</v-icon>
                  <span>エラーが発生しました</span>
                </p>
                <v-btn @click="onBack">戻る</v-btn>
              </div>
            </template>
            <template v-else>
              <CCard bodyWrapper>
                <CContainer style="padding: 0;">
                  <CRow>
                    <CCol :lg="12" class="py-0">
                      <v-row
                        class="pa-1"
                        align="start"
                        justify="start"
                        :style="{ 'min-height': rowMinHeight }"
                      >
                        <v-flex :class="$style['label']" row style="max-width: 250px !important;">
                          <Label label="質問テキスト" />
                        </v-flex>
                        <div class="flex-grow-1 d-flex align-center">
                          {{ question }}
                        </div>
                      </v-row>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol :lg="12" class="py-0">
                      <v-row
                        class="pa-1"
                        align="start"
                        justify="start"
                        :style="{ 'min-height': rowMinHeight }"
                      >
                        <v-flex :class="$style['label']" row style="max-width: 250px !important;">
                          <Label label="回答と回答人数" />
                        </v-flex>
                        <div class="flex-grow-1 d-flex align-center">
                          <CChartBar
                            style="width:600px;height:600px;"
                            :datasets="[
                              {
                                data: data,
                                backgroundColor: '#87ceeb',
                                label: '回答数',
                              }
                            ]"
                            :labels="labels"
                            :options="options"
                          />
                        </div>
                      </v-row>
                    </CCol>
                  </CRow>
                </CContainer>
              </CCard>
            </template>
          </template>
        </div>
      </v-content>
    </div>
  </v-container>
</template>

<script>
import ToolBar from "@/components/app/toolbar";
import FieldGenerator from "@/components/field/generator";
import TextField from "@/components/field/text";
import Label from "@/components/field//label";
import utility from "@/utility";
import Breadcrumb from "@/components/app/breadcrumb";

export default {
  components: {
    ToolBar,
    Breadcrumb,
    FieldGenerator,
    Label,
    TextField
  },
  props: {
    resourceName: {
      type: String,
      required: true
    },
    pk: {
      type: String,
      required: true
    },
    productId: {
      type: String,
      required: true
    },
    breadcrumbs: {
      type: Array,
      default: () => []
    },
    rowMinHeight: {
      type: String,
      default: "40px"
    },
  },
  data() {
    return {
      options: {
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                stepSize: 1
              }
            }
          ]
        }
      }
    }
  },
  computed: {
    entity() {
      return this.$store.getters[`${this.resourceName}/list/entity`];
    },
    data() {
      return this.entity.statistics.map(item => item.count);
    },
    labels() {
      return this.entity.statistics.map(item => item.answer_title);
    },
    question() {
      return this.entity.question;
    },
    loading() {
      return this.$store.getters[`${this.resourceName}/list/isLoading`];
    },
    loaded() {
      return this.$store.getters[`${this.resourceName}/list/isLoaded`];
    },
    processing() {
      return this.$store.getters[`${this.resourceName}/list/isProcessing`];
    },
    error() {
      return this.$store.getters[`${this.resourceName}/list/error`];
    }
  },
  methods: {
    onRefresh() {
      this.$store.dispatch(`${this.resourceName}/list/show`, {
        pk: this.pk,
        productId: this.productId
      });
    },
    onBack() {
      this.$router.push({ path: `/${this.resourceName}` });
    }
  }
};
</script>

<style module lang="scss">
$base-app-header-height: 75px;
$base-header-height: 55px;
$base-footer-height: 60px;

.control-button{
  font-size: 0.875rem !important;
}

.control-button-s{
  font-size: 0.5rem !important;
}

.container.container {
  width: 100%;
  height: calc(100% - #{$base-app-header-height});
  padding: 0;
  position: relative;

  .container-header {
    height: $base-header-height !important;
  }

  .container-content {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    height: calc(100% - #{$base-header-height});
    overflow: hidden;

    .main-content {
      height: calc(
        100vh - #{$base-header-height} - #{$base-footer-height}
      );
      padding: 8px;
      overflow-y: auto;
      overflow-x: hidden;
    }

    .container-error {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      p {
        color: #ff0000;
        i {
          margin: 0 10px 0 0;
        }
        i,
        span {
          vertical-align: middle;
        }
      }
    }
  }

  .container-footer {
    height: $base-footer-height !important;
  }
}

.datepicker{
  div > input{
    border: 1px ridge #333333;
    display: block;
    margin: 5px 5px 10px;
  }
}
</style>
